import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import appStore from "../../../storage/AppStore";
import clubStore from "../../../storage/ClubStore";
import {Link} from 'react-router'
import NoResult from "../../NoResult/NoResult";

const Branches = () => {
    useEffect(() => {
        clubStore.getBranches();
    }, []);
    return (
        <div className="row justify-content-center">
            <div className="flex flex-row w-100 justify-content-between px-3 my-2">
                <div className="flex align-items-center">
                    <b className="card-header">{appStore.tr.branches} ({clubStore.branches.length})</b>
                </div>
                <div className="flex align-items-center">
                    <Link to="/manager/branch/new" className="btn btn-sm btn-icon btn-success align-self-end">
                        <i className="ci-plus-square"/>
                    </Link>
                </div>
            </div>
            {clubStore.branches.length === 0 &&
                <NoResult/>
            }
            {clubStore.branches.map((branch, index) => (
                <div key={index} className="col-lg-3 col-md-6 col-sm-12 col-xs-12 px-3 d-flex mb-3">
                    <div className="card mb-3 shadow-sm h-100 w-100 d-flex flex-column">
                        <div className="card-body d-flex flex-column">
                            <div>
                                <h6 className="mb-1">
                                    {branch.name}
                                </h6>
                                <p className="mb-1 text-muted">{branch.address}</p>
                                <div className="mt-auto pt-3">
                                    <div className="d-grid gap-2">
                                        <Link className={"btn btn-sm btn-primary"}
                                              to={`/manager/branch/edit/${branch.id}`}><i
                                            className="ci ci-edit-2"/></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default observer(Branches);